var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('Heading',{attrs:{"title":_vm.$t('accessDenied.title')}}),_c('Description',{attrs:{"description":_vm.$t('accessDenied.description')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }